import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  padding: ${themeGet('spacing.lg')} ${themeGet('spacing.xl')};
  gap: ${themeGet('spacing.2xl')};
  border-radius: ${themeGet('borderRadius.md')};
  background-color: ${themeGet('colors.gray.50')};
`;
export const Copy = styled.div `
  flex-direction: column;
  display: flex;
`;
export const SwitchContainer = styled.div `
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: ${themeGet('spacing.md')};
`;
export const Row = styled.div `
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.2xl')};
`;
